module.exports = __webpack_public_path__ + "static/media/typeCVersion2.b6e080f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hotspots/landing/typeCVersion2.png
// module id = 1251
// module chunks = 0